import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';

import {roomDetailsSelector, paymentModuleOpenSelector} from '@ibibo/hotels-review-reducer';

import SpecialDeal from '../SpecialDeal/SpecialDeal';
import HotelDetailsReview from '../HotelDetailsReview/HotelDetailsReview';
import RoomType from '../RoomType/RoomType';
import HotelInclusion from '../HotelInclusion/HotelInclusion';
import HotelDetailsHeader from '../HotelDetailsHeader/HotelDetailsHeader';

import HotelInfoLoader from '../../Loadingpage/ReviewPageLoaders/HotelInfoLoader/HotelInfoLoader';

import {freeBreakfastOrCancellationPersuasionAndAdditionalPersuasionSelector} from '../../../../../shared/pages/DetailsPage/selectors';

const HotelDetailsBlock: React.FC<{loading: boolean; earlycheckin: boolean}> = ({
  loading,
  earlycheckin,
}) => {
  const {
    roomType,
    numberOfRooms,
    freeCancellationDate,
    hotelStars,
    addOnList,
    extraMessages,
    hotelsPolicy,
    cancellationPolicy,
    thingsYoushouldKnow,
    gdsCancellationText,
    gdsHotelPolicy
  } = useSelector(roomDetailsSelector);
  const payModuleOpen = useSelector(paymentModuleOpenSelector);

  const {additionalPersuasion} = useSelector(
    freeBreakfastOrCancellationPersuasionAndAdditionalPersuasionSelector,
  );

  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (payModuleOpen && open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [payModuleOpen]);

  return (
    <HotelDetailsWrapDiv>
      {(loading && <HotelInfoLoader />) || (
        <HotelDetailsInnerWrapDiv>
          <HotelDetailsHeader openStatus={open} setOpen={setOpen}></HotelDetailsHeader>
          <HotelDetailsInfoWrap>
            {/* <SpecialDeal deals={additionalPersuasion}></SpecialDeal> */}
            <HotelDetailsReview hotelStars={hotelStars}></HotelDetailsReview>
            {/* <DurationBlock></DurationBlock> */}
            {(open && <RoomTypeInclusionWrap>
              <RoomType roomType={roomType} numberOfRooms={numberOfRooms} />
              <HotelInclusion
                freeCancellationDate={freeCancellationDate}
                addOnList={addOnList}
                earlycheckin={earlycheckin}
                roomType={roomType}
                extraMessages={extraMessages}
                hotelsPolicy={hotelsPolicy}
                cancellationPolicy={cancellationPolicy}
                thingsYoushouldKnow={thingsYoushouldKnow}
              ></HotelInclusion>
            </RoomTypeInclusionWrap>) || null}
          </HotelDetailsInfoWrap>
        </HotelDetailsInnerWrapDiv>
      )}
    </HotelDetailsWrapDiv>
  );
};

export default HotelDetailsBlock;

const HotelDetailsWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
`,
);

const HotelDetailsInnerWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
    background-color: ${props.theme.colors.white.base};
    border-radius: 1rem;
    box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
`,
);

const HotelDetailsInfoWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l20};
    border-top: 1px solid ${props.theme.colors.grey.lighte7};
  `
);

const RoomTypeInclusionWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    border: 1px solid ${props.theme.colors.grey.lighte7};
    border-radius: ${props.theme.misc.borderRadius.base};
    flex-direction: column;
  `
)
